import { ResponseService } from './../services/response.service';
import { LocalStorageService } from './../services/local-storage.service';
import { BreadcrumbsService } from './../services/breadcrumbs.service';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { NotificationsService } from 'angular2-notifications';
import { BreadcrumbService } from 'ng2-breadcrumb/ng2-breadcrumb';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { ActivationService } from './../services/activation.service';
import { Response } from '@angular/http';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { CustomFormsModule, CustomValidators } from 'ng2-validation';
import { CustomDSValidators } from './../shared/validators/custom-validators';
import 'rxjs/add/operator/filter';

@Component({
  selector: 'app-main',
  templateUrl: './confirm.component.html',
})

export class ActivationComponent implements OnInit {

  public loading: Boolean = false;
  public activationStatus: any = null;
  token: any;
  sub: any;

  constructor(
    public activationService: ActivationService,
    private router: Router,
    private route: ActivatedRoute,
    private notificationService: NotificationsService,
    private translateService: TranslateService,
    private responseService: ResponseService,
  ) { }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.token = params['token'];
    });

    setTimeout(arg => {
      this.startActivation();
    }, 100);
  }

  startActivation() {
    this.activationService.activeAccount(this.token);
  }
}




// WEBPACK FOOTER //
// ./src/app/activation/confirm.component.ts